import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const particles = Array.from({ length: 80 }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      vx: (Math.random() - 0.5) * 0.4,
      vy: (Math.random() - 0.5) * 0.4,
      size: Math.random() * 1.5 + 0.5,
      opacity: Math.random() * 0.5 + 0.1,
    }));

    let raf;
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0) p.x = canvas.width;
        if (p.x > canvas.width) p.x = 0;
        if (p.y < 0) p.y = canvas.height;
        if (p.y > canvas.height) p.y = 0;

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(0, 240, 255, ${p.opacity})`;
        ctx.fill();

        particles.forEach((p2) => {
          const dx = p.x - p2.x, dy = p.y - p2.y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 120) {
            ctx.beginPath();
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.strokeStyle = `rgba(0, 240, 255, ${0.08 * (1 - dist / 120)})`;
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        });
      });
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => cancelAnimationFrame(raf);
  }, []);

  const cards = [
    { path: '/cables-design', icon: '⟜', title: 'Cables Design', desc: 'Engineering schematics & routing blueprints for high-performance cable assemblies', color: '#00f0ff' },
    { path: '/connectors-stock', icon: '◈', title: 'Connectors Stock', desc: 'Real-time inventory tracking for industrial connector components & interfaces', color: '#7b2fff' },
    { path: '/cable-stock', icon: '≋', title: 'Cable Stock', desc: 'Comprehensive warehouse management for cable bundles & raw materials', color: '#ff6b00' },
  ];

  return (
    <div className="home-page">
      <canvas ref={canvasRef} className="particle-canvas" />
      
      <div className="home-content">
        <div className="hero-section">
          <div className="hero-badge">
            <span className="badge-dot" />
            <span>SYSTEM ONLINE</span>
          </div>
          <h1 className="hero-title">
            <span className="title-line">AGAM</span>
            <span className="title-line accent">ROBOTICS</span>
            <span className="title-sub">INTERNALS MANAGEMENT SYSTEM</span>
          </h1>
          <p className="hero-desc">
            Next-generation inventory & design management for precision robotics manufacturing. 
            Monitor, track, and engineer with unparalleled clarity.
          </p>
        </div>

        <div className="cards-grid">
          {cards.map((card) => (
            <div key={card.path} className="nav-card" onClick={() => navigate(card.path)} style={{ '--card-color': card.color }}>
              <div className="card-corner tl" />
              <div className="card-corner tr" />
              <div className="card-corner bl" />
              <div className="card-corner br" />
              <div className="card-icon">{card.icon}</div>
              <h3 className="card-title">{card.title}</h3>
              <p className="card-desc">{card.desc}</p>
              <div className="card-cta">
                <span>ENTER MODULE</span>
                <span className="cta-arrow">→</span>
              </div>
              <div className="card-glow" />
            </div>
          ))}
        </div>

        <div className="status-bar">
          <div className="status-item"><span className="s-dot green"/>NETWORK CONNECTED</div>
          <div className="status-item"><span className="s-dot cyan"/>DATABASE SYNCED</div>
          <div className="status-item"><span className="s-dot orange"/>3 MODULES ACTIVE</div>
          <div className="status-item mono">v2.4.1 // BUILD 2025.02</div>
        </div>
      </div>
    </div>
  );
};

export default Home;
